<template>
  <div class="p-16">
    <div class="max-w-5xl mx-auto space-y-16">Landing</div>
  </div>
</template>

<script>
export default {
  name: 'Landing',
};
</script>
